import React, { useState, useEffect, useRef } from "react";
import SearchiconBar from "../../Assets/Images/CommanImages/searchiconwithbar.png";
import Colors from "../../Constants/Colors";
import "./SearchdropdownforlistdataSingleSelect.css";
const SearchDropdown = ({
  initialOptions = [],
  onSelect,
  onInputChange, // NEW PROP: callback when the input text changes
  placeholder = "Search...",
  label = "Search Dropdown",
  labelKey = (option) => option.label, // Function to get the label from an option
  dropdownStyle = {},
  inputStyle = {},
  optionStyle = {},
  optionClassName = "",
  selected = null,
  hasError = false,
}) => {
  const [searchKey, setSearchKey] = useState(""); // User's input
  const [filteredOptions, setFilteredOptions] = useState(initialOptions); // Filtered options
  const [showOptions, setShowOptions] = useState(false); // Dropdown visibility
  const [selectedOption, setSelectedOption] = useState(null); // Selected option
  const [focusedIndex, setFocusedIndex] = useState(-1); // Highlighted option index
  const dropdownRef = useRef(null);
  const optionRefs = useRef([]); // Array of refs for each option

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // When initialOptions changes from the parent (or when filtering externally) update the filtered options.
  useEffect(() => {
    setFilteredOptions(initialOptions);
  }, [initialOptions]);

  // Sync external selected value with internal state
  useEffect(() => {
    if (selected) {
      setSelectedOption(selected);
      setSearchKey(""); // Clear manual search key to show selected value
    } else {
      setSelectedOption(null);
      setSearchKey("");
    }
  }, [selected]);

  // Additionally filter based on the local search key (if not empty)
  useEffect(() => {
    if (searchKey === "") {
      setFilteredOptions(initialOptions);
    } else {
      setFilteredOptions(
        initialOptions.filter((option) =>
          labelKey(option).toLowerCase().includes(searchKey.toLowerCase())
        )
      );
    }
    setFocusedIndex(-1); // Reset focused index when filtering options
  }, [searchKey, initialOptions, labelKey]);

  // Scroll into view when focusedIndex changes
  useEffect(() => {
    if (focusedIndex > -1 && optionRefs.current[focusedIndex]) {
      optionRefs.current[focusedIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [focusedIndex]);

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setShowOptions(true);
      setFocusedIndex((prevIndex) =>
        prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setShowOptions(true);
      setFocusedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredOptions.length - 1
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (filteredOptions.length > 0) {
        if (focusedIndex >= 0) {
          handleSelect(filteredOptions[focusedIndex]);
        } else {
          // If no option is focused, default to the first option
          handleSelect(filteredOptions[0]);
        }
      }
    }
  };

  const handleSelect = (option) => {
    setSelectedOption(option); // Save the selected option
    onSelect(option); // Pass the selected option to the parent
    setSearchKey(""); // Clear the search input
    setShowOptions(false); // Close the dropdown
    setFocusedIndex(-1); // Reset the focused index
  };

  const handleClear = () => {
    setSelectedOption(null); // Clear the selected option
    setSearchKey(""); // Clear the search input
    onSelect(null); // Notify the parent that the selection is cleared
    setFocusedIndex(-1);
  };

  return (
    <div
      className="search-dropdown"
      style={{ position: "relative", ...dropdownStyle }}
      ref={dropdownRef}
    >
      <label
        style={{
          fontSize: "14px",
          color: "grey",
          marginBottom: "5px",
          display: "inline-block",
        }}
      >
        {label}
      </label>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          border: hasError ? "1px solid #ff0000" : `1px solid ${Colors.color3}`,
        }}
      >
        <input
          type="text"
          // placeholder={selectedOption ? labelKey(selectedOption) : placeholder} // Show selected value or placeholder
          placeholder={selectedOption ? labelKey(selectedOption) : placeholder}
          // value={searchKey}
          value={searchKey || (selectedOption ? labelKey(selectedOption) : "")}
          onChange={(e) => {
            setSearchKey(e.target.value);
            if (onInputChange) onInputChange(e.target.value);
            setShowOptions(true); // Show dropdown while typing
          }}
          onKeyDown={handleKeyDown}
          style={{
            width: "100%",
            padding: "8px",
            color: "#6A6A6A",
            // border: `1px solid ${Colors.color1}`,
            border: "none",
            ...inputStyle,
          }}
        />
        {(selectedOption || searchKey) && (
          <button
            onClick={handleClear}
            style={{
              position: "absolute",
              right: "35px",
              background: "none",
              border: "none",
              color: "grey",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            ✕
          </button>
        )}
        <img
          src={SearchiconBar}
          style={{ width: "25px", height: "25px", marginRight: "4px" }}
          alt=""
        />
      </div>
      {showOptions && (
        <div
          className="dropdown-options"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            maxHeight: "200px",
            overflowY: "auto",
            border: "1px solid #ccc",
            backgroundColor: "#fff",
            zIndex: 1000,
            gap: "2px",
            marginTop: "2px",
            ...dropdownStyle,
          }}
        >
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                ref={(el) => (optionRefs.current[index] = el)}
                onMouseEnter={() => setFocusedIndex(index)}
                onMouseLeave={() => setFocusedIndex(-1)}
                onClick={() => handleSelect(option)}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  color: "#6A6A6A",
                  backgroundColor:
                    index === focusedIndex ? "#f0f0f0" : "transparent",
                  ...optionStyle,
                }}
                className={optionClassName}
              >
                {labelKey(option)}
              </div>
            ))
          ) : (
            <div
              style={{
                padding: "8px",
                color: "#999",
                ...optionStyle,
              }}
            >
              No results found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;